<section class="PaymentCardBillNumber">
  <hr class="PaymentCardBillNumber__Separator" />
  @if (billNumber) {
    <dl class="PaymentCardBillNumber__DescriptionList">
      <dt class="PaymentCardBillNumber__DescriptionTerm">
        {{ config?.billNumber.label }}
      </dt>
      <dd class="PaymentCardBillNumber__DescriptionDefinition">
        {{ billNumber }}
      </dd>
    </dl>
  }
  @if (billPeriod) {
    <dl class="PaymentCardBillNumber__DescriptionList">
      <dt class="PaymentCardBillNumber__DescriptionTerm">
        {{ config?.billPeriod.label }}
      </dt>
      <dd class="PaymentCardBillNumber__DescriptionDefinition">
        {{ billPeriod }}
      </dd>
    </dl>
  }
</section>
